import React, { useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import template from "../../../../assets/templates/BovExo_template_fornecedores_clientes.xlsx";
import { Creators as AppActions } from "../../../../store/ducks/app";
import { Row, Col, Icon, Upload, notification, Spin } from "antd";
import ButtonStandard from "../../../utils/button";
import GroupFarmSelector from "../../../utils/groupFarmSelector";
import {
  CustomModal,
  Container,
  Header,
  Title,
  ButtonWithoutBackground,
  DownloadButton,
} from "./styles";
import { importSuppliersAndClients } from "../../../../services/importService";

const SuppliersClientsUploadModal = () => {
  const [fileList, setFileList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [importScope, setImportScope] = useState("SpecificFarm");

  const props = {
    accept: ".xlsm, .xlsx",
    onRemove: (file) => {
      setFileList([]);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    showUploadList: false,
    fileList,
  };
  const { Dragger } = Upload;

  // Redux Variables
  const {
    translation,
    modalSuppliersClientsUploadVisible,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  // Methods
  const handleCancel = () => {
    setIsLoading(false);
    setFileList([]);
    setImportScope("SpecificFarm");
    dispatch(AppActions.hideModalSuppliersClientsUpload());
  };

  const handleUpload = async () => {
    try {
      setIsLoading(true);

      // TODO: Implementar serviço de importação de fornecedores/clientes
      const results = await importSuppliersAndClients({
        groupId,
        farmId,
        importScope,
        file: fileList[0],
        scope: importScope,
      });

      notification.success({
        message: translation.importSuppliersClients.success.title,
        description: translation.importSuppliersClients.success.description,
        duration: 5,
      });

      handleCancel();
    } catch (error) {
      notification.error({
        message: translation.importSuppliersClients.error.title,
        description: translation.importSuppliersClients.error.description,
        duration: 2,
      });
      handleCancel();
    }
  };

  return (
    <CustomModal
      width={535}
      visible={modalSuppliersClientsUploadVisible}
      centered
      maskClosable={false}
      closable={false}
      footer={null}
    >
      <Container>
        <Spin spinning={isLoading}>
          <Header>
            <Title>{translation.importSuppliersClients.title}</Title>
          </Header>

          {/* Message */}
          <Row type="flex" justify="start">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div
                dangerouslySetInnerHTML={{
                  __html: translation.importSuppliersClients.message,
                }}
              />
            </Col>
          </Row>
          <Row type="flex" justify="start">
            <Col xs={24} sm={24} md={24} lg={24} xl={24} align="left">
              <DownloadButton
                href={template}
                download="BovExo_template_fornecedores_clientes.xlsx"
              >
                <Icon type="download" />
                {translation.buttons.download}
              </DownloadButton>
            </Col>
          </Row>

          {/* Group/Farm Selection */}
          <Row type="flex" justify="start" style={{ marginTop: "20px" }}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <GroupFarmSelector
                value={importScope === "SpecificFarm" ? "farm" : "group"}
                onChange={(e) =>
                  setImportScope(
                    e.target.value === "farm" ? "SpecificFarm" : "FarmsGroup"
                  )
                }
                translationKey="importSuppliersClients.groupFarmVisibility"
                showGroupName={true}
              />
            </Col>
          </Row>

          {/* Upload area */}
          <Row type="flex" className="uploadRow">
            <Row type="flex">
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Dragger {...props}>
                  {fileList.length > 0 ? (
                    <Fragment>
                      <p className="ant-upload-drag-icon">
                        <Icon type="file-excel" />
                      </p>
                      <p className="ant-upload-text">{fileList[0].name}</p>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <p className="ant-upload-drag-icon">
                        <Icon type="inbox" />
                      </p>
                      <p className="ant-upload-text">
                        {translation.importSuppliersClients.draggerMessage}
                      </p>
                    </Fragment>
                  )}
                </Dragger>
              </Col>
            </Row>

            <Row
              type="flex"
              className="footer"
              justify="space-between"
              align="middle"
            >
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <ButtonStandard
                  type="button"
                  buttonType="type4"
                  size="s"
                  onClick={handleCancel}
                >
                  {translation.buttons.cancel}
                </ButtonStandard>
              </Col>
              <Col xs={16} sm={16} md={16} lg={16} xl={16} align="right">
                <ButtonWithoutBackground
                  type="submit"
                  onClick={handleUpload}
                  disabled={fileList.length === 0}
                >
                  {translation.buttons.process}
                </ButtonWithoutBackground>
              </Col>
            </Row>
          </Row>
        </Spin>
      </Container>
    </CustomModal>
  );
};

export default SuppliersClientsUploadModal;
